import { render, staticRenderFns } from "./JobworkInvoiceForm.vue?vue&type=template&id=272a56d2&scoped=true"
import script from "./JobworkInvoiceForm.vue?vue&type=script&lang=js"
export * from "./JobworkInvoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272a56d2",
  null
  
)

export default component.exports